import { render, staticRenderFns } from "./SuportCreateTicket.vue?vue&type=template&id=76e738a9&"
import script from "./SuportCreateTicket.vue?vue&type=script&lang=js&"
export * from "./SuportCreateTicket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76e738a9')) {
      api.createRecord('76e738a9', component.options)
    } else {
      api.reload('76e738a9', component.options)
    }
    module.hot.accept("./SuportCreateTicket.vue?vue&type=template&id=76e738a9&", function () {
      api.rerender('76e738a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/faq/SuportCreateTicket.vue"
export default component.exports